import { appendInitialSendMessages } from './helpers/appendInitialSendMessages'
import { ensureSendThreadId } from './helpers/ensureSendThreadId'
import { createThreadAbortController } from './helpers/threadAbortController'
import { markOpenAgentQuestionAnsweredBeforeSend } from '@/features/chat/agentQuestion/markAgentQuestionAnswered.js'

/** @param {object} m @param {{ text: string, files?: unknown[], mode?: string, connectContext?: unknown, forceNewThread?: boolean, agentQuestionAnswer?: object }} payload */
export function runSendMessage(m, payload) {
  const { text, files, mode, connectContext, forceNewThread = false, agentQuestionAnswer } = payload
  const {
    activePrimaryKey,
    displayThreadId,
    navThreads,
    setThreads,
    setSelectedThreadId,
    chatAbortRef,
    setMessagesByThreadId,
  } = m
  if (activePrimaryKey !== 'home') return
  const trimmed = text.trim()
  if (!trimmed && (!files || files.length === 0)) return
  const tid = ensureSendThreadId({
    currentId: displayThreadId,
    forceNewThread,
    validIds: navThreads.map((t) => t.id),
    setThreads,
    setActiveThreadId: setSelectedThreadId,
    trimmed,
    files,
  })
  markOpenAgentQuestionAnsweredBeforeSend({
    setMessagesByThreadId,
    threadId: tid,
    answer: agentQuestionAnswer || { sendText: trimmed },
  })
  chatAbortRef.current?.abort()
  const controller = createThreadAbortController(tid)
  chatAbortRef.current = controller
  const { signal } = controller
  setMessagesByThreadId((prev) =>
    appendInitialSendMessages(prev, {
      tid,
      trimmed,
      files,
      mode,
      signal,
      setMessagesByThreadId,
      connectContext,
    }),
  )
}
